import { useDispatch, useSelector } from "react-redux";
import { RootState, AppDispatch } from "../../store/store";

import {
    setReport,
    setLoading,
    clearReport
} from "../../store/slices/cash/cashReportSlice";

import useApiErrorHandler from "../useApiErrorHandler";
import useLoading from "../useLoading";

import CashReportService from "../../services/cash/CashReportService";

export const useCashReport = () => {

    const dispatch: AppDispatch = useDispatch();

    const { report, loading } = useSelector(
        (state: RootState) => state.cashReport
    );

    const { handle } = useApiErrorHandler();
    const { showLoadingIndicator, hideLoadingIndicator } = useLoading();

    /**
     * 📊 Obtener Corte X
     */
    const getXReport = async () => {

        try {

            showLoadingIndicator();
            dispatch(setLoading(true));

            const response = await CashReportService.getXReport();

            console.log(response);

            if (response?.statusCode === 200) {
                dispatch(setReport(response.data));
            }

        } catch (error) {

            handle(error);

        } finally {

            hideLoadingIndicator();
            dispatch(setLoading(false));

        }

    };

    const clear = () => {
        dispatch(clearReport());
    };

    return {

        report,
        loading,

        getXReport,
        clearReport,
        clear,

    };

};